export class CellInfo {
    constructor(dta) {
        this.sizes = undefined;
        this.row = dta.row;
        this.tier = dta.tier;
        this.restricted = dta.restricted;
        this.pairedBay = dta.pairedBay;
        this.isReefer = dta.isReefer;
        this.sizes = Object.keys(dta.sizes || {}).map(Number).reduce((acc, size) => {
            var _a;
            if ((_a = dta.sizes) === null || _a === void 0 ? void 0 : _a[size])
                acc.set(size, dta.sizes[size]);
            return acc;
        }, new Map());
        this.maxSize = dta.maxSize;
    }
    has40Size() {
        return !!(this.maxSize !== undefined && this.maxSize >= 40);
    }
    getLcg(size) {
        var _a, _b;
        return (_b = (_a = this.sizes) === null || _a === void 0 ? void 0 : _a.get(size)) === null || _b === void 0 ? void 0 : _b.lcg;
    }
    getTcg(size) {
        var _a, _b;
        return (_b = (_a = this.sizes) === null || _a === void 0 ? void 0 : _a.get(size)) === null || _b === void 0 ? void 0 : _b.tcg;
    }
    getBottomBase(size) {
        var _a, _b;
        return (_b = (_a = this.sizes) === null || _a === void 0 ? void 0 : _a.get(size)) === null || _b === void 0 ? void 0 : _b.bottomBase;
    }
    getCGs(size) {
        return {
            lcg: this.getLcg(size),
            tcg: this.getTcg(size),
            bottomBase: this.getBottomBase(size),
        };
    }
}
